module.exports = __webpack_public_path__ + "img/rz_2.7ce2aee2.png";